import { SearchVehiclesApiParams } from '../types'

const convertSearchParamsToUrlSearchParams = (
  params: Partial<SearchVehiclesApiParams>,
): URLSearchParams =>
  new URLSearchParams(
    Object.entries(params).map(([key, value]) => {
      if (Array.isArray(value)) {
        return [key, value.join(',')]
      }
      return [key, `${value}`]
    }),
  )

export const getVehiclesUrlForSearchParams = (
  searchServiceUrl: string,
  params?: Partial<SearchVehiclesApiParams>,
  channelId?: string,
) => {
  const urlSearchParams = params
    ? convertSearchParamsToUrlSearchParams(params)
    : new URLSearchParams()

  if (channelId) {
    urlSearchParams.set('channelId', channelId)
  }

  const queryString = `${urlSearchParams}`

  return `${searchServiceUrl}/vehicles${queryString ? `?${queryString}` : ''}`
}
